


function Card(props) {
    return (
        <div className="hw-card">
            {/* <img src={props.info.img} alt="ciao"/> */}
            <h4>{props.info.title}</h4>
            <p>{props.info.text}</p>
        </div>
    )
}

export default Card